var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTeams = function SvgIconTeams(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1302_4245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 16.6666C9.61667 16.6666 2 18.6166 2 22.4999V27H25V22.4999C25 18.6166 17.3833 16.6666 13.5 16.6666ZM26.6167 16.9167C26.1333 16.9167 25.5833 16.95 25 17C26.9333 18.4 28 20.0333 28 22.4999V27H38V22.4999C38 18.6166 30.5 16.9167 26.6167 16.9167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 8.5C18 10.9853 15.9853 13 13.5 13C11.0147 13 9 10.9853 9 8.5C9 6.01472 11.0147 4 13.5 4C15.9853 4 18 6.01472 18 8.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 8.5C32 10.9853 29.9853 13 27.5 13C25.0147 13 23 10.9853 23 8.5C23 6.01472 25.0147 4 27.5 4C29.9853 4 32 6.01472 32 8.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1302_4245"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 32,
    fill: "white"
  })))));
};
export default SvgIconTeams;